import AuthService from '../../service';
const MainPage = {
  showMainPage(id){
    return AuthService.get(`main-page/${id}`);
  },
  updateMainPage(id,data){
    return AuthService.put(`main-page/${id}`,data);
  }
}
export default MainPage
